
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexidyDttn2nAtfyKcnzRUSqhwnL7kztssg1Rdvj0_45dfSAMeta } from "/workspace/pages/index.vue?macro=true";
import { default as login97SE8CiapI7px7MAPs_LAxy70sgxkGME4yvEGXGqiLoMeta } from "/workspace/pages/auth/login.vue?macro=true";
import { default as _91id_934oj6rY0I_ZFucaVCXYpj8vu1xwkMclSsJdl_45H6eLxy8Meta } from "/workspace/pages/reports/[id].vue?macro=true";
import { default as indexvOrpK_45kgu4oK_45vPqfNo4ptXIMq8_45y2q_45kRCMCy6oJG0Meta } from "/workspace/pages/reports/index.vue?macro=true";
import { default as registerxnn0cBl6YNLkaHhB7ZttJp28i3euDU3Fz5TpmjhyMewMeta } from "/workspace/pages/reports/register.vue?macro=true";
import { default as indexQKlqPvulkuQTuXJ7Q1txjpNuTkcx1nSuZsWxead_gm4Meta } from "/workspace/pages/constructions/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/workspace/pages/index.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    component: () => import("/workspace/pages/auth/login.vue")
  },
  {
    name: "reports-id",
    path: "/reports/:id()",
    component: () => import("/workspace/pages/reports/[id].vue")
  },
  {
    name: "reports",
    path: "/reports",
    component: () => import("/workspace/pages/reports/index.vue")
  },
  {
    name: "reports-register",
    path: "/reports/register",
    component: () => import("/workspace/pages/reports/register.vue")
  },
  {
    name: "constructions",
    path: "/constructions",
    component: () => import("/workspace/pages/constructions/index.vue")
  }
]